export default __webpack_public_path__ + "static/automated_escalations-fb4742cf144e86bc4614c70ad94155b2.svg";